/**
 * Client telemetry and build identity marker.
 *
 * Eagerly references build-time environment constants so that bundlers (Vite/Rolldown)
 * retain them in the output artifact for telemetry and smoke verification.
 */
const clientBuildIdentity = {
  appVersion: import.meta.env.APP_VERSION,
  COMMIT_HASH: import.meta.env.COMMIT_HASH,
};

declare global {
  interface Window {
    __BUILD_IDENTITY__?: typeof clientBuildIdentity;
  }
}

if (typeof window !== "undefined") {
  window.__BUILD_IDENTITY__ = clientBuildIdentity;
}
